<template>
  <div id="empty_data" class="flex-center">
    <span>{{ dataTp }}{{ getParticle(dataTp) }} 없습니다.</span>
    <span v-if="desc">{{ desc }}</span>
  </div>
</template>
<script>
export default {
  name: '',
  props: {
    dataTp: {
      type: String,
      default: '데이터'
    },
    desc: {
      type: String,
      default: ''
    }
  },
  data() {
    return {}
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  destroyed() {},
  methods: {
    getParticle(word) {
      if (!word) return '가'

      const lastChar = word.charAt(word.length - 1)
      const lastCharCode = lastChar.charCodeAt(0)

      // 한글인지 확인
      if (lastCharCode >= 0xac00 && lastCharCode <= 0xd7a3) {
        // 받침 유무 확인 (한글 유니코드 계산)
        const hasBatchim = (lastCharCode - 0xac00) % 28 !== 0
        return hasBatchim ? '이' : '가'
      }

      // 한글이 아닌 경우 기본값
      return '가'
    }
  }
}
</script>
<style lang="scss" scoped>
#empty_data {
  min-height: 240px;

  max-height: 620px;
  max-width: 1280px;
  margin: 0 auto;

  // background: url();
}
</style>
